import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=08a26f24&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=js&"
export * from "./FormData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a26f24",
  null
  
)

export default component.exports